export default __webpack_public_path__ + "static/media/bg-valdano-bio-01@2x.9e73e0d6.jpg";